import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Button, Offcanvas, Nav, Accordion } from 'react-bootstrap'
import useAuth from '../../context/auth/useAuth'
import { Link, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import SchoolCalendar from '../calendars/SchoolCalendar'
import { useTranslation } from 'react-i18next'

export const HeaderMultiSchool = () => {
    const { t } = useTranslation()
	const {client} = useAuth()
    const dispatch = useDispatch()
    const location = useLocation()

    const [show, setShow] = useState(false)
	const handleClose = () => setShow(false)
	const handleShow = () => setShow(true)
    const [showCalendar, setShowCalendar] = useState(false)
    const {scheduleQty} = useSelector(state => state.chooses)

    const isactiveProcessesActive = (path) => {
		let isActive = false

		if (location.pathname === '/multischool/activeprocesses') {
			isActive = true
		}
		
		if (/^\/multischool\/overviewprocess\/[a-zA-Z0-9]/.test(path)) {
			isActive = true
		}

		if (/^\/multischool\/overviewprocess\/[a-zA-Z0-9]+\/candidates$/.test(path)) {
			isActive = true
		}

		if (/^\/multischool\/overviewprocess\/[a-zA-Z0-9]+\/precandidates$/.test(path)) {
			isActive = true
		}

		return isActive
	}

	const isSchoolsManagementActive = (path) => {
		let isActive = false

		if (location.pathname === '/multischool/schools') {
			isActive = true
		}
		
		if (/^\/multischool\/schools\/[a-zA-Z0-9]/.test(path)) {
			isActive = true
		}

		if (/^\/multischool\/schools\/[a-zA-Z0-9]+\/edit$/.test(path)) {
			isActive = true
		}

		return isActive
	}

    useEffect(() => {
        if(client){
            // TODO: Cambiar llamada para obtener las entrevistas por supercentro
            // dispatch(getSchool(client?.id))
        }
    },[dispatch, client])

    return (
        <header>
            <Container>
                <Row className='my-1 d-flex justify-content-between'>
                    <Col className='d-flex align-items-center'>
                        <Button variant="primary" onClick={handleShow} className='d-block d-sm-none'>
                            icono
                        </Button>
                        <Link to="/multischool/dashboard">
                            <img src='/images/logotipo.svg' alt="Logotipo Skill Connected" />
                        </Link>
                    </Col>
                    <Col className='d-flex justify-content-end align-items-center'>
                        <a className='ms-3 cursor alert-container' onClick={() => setShowCalendar(true)}>
                            <img src="/images/menus/calendar.svg" alt="Icono Calendario" />
                            {scheduleQty > 0 && <span className='alert-badge'></span>}
                        </a>  
                        <div  className='d-block d-lg-none ms-3'>
                            <i className='fa fa-bars cursor color-primary' onClick={handleShow}></i>
                        </div>                      
                    </Col>
                </Row>
            </Container>
            <Offcanvas show={show} onHide={handleClose}>
				<Offcanvas.Header closeButton>
				    <Offcanvas.Title>
                        <Link to="/multischool/dashboard" onClick={handleClose}>
                            <img src='/images/logotipo.svg' alt="Logotipo Skill Connected" />
                        </Link>
                    </Offcanvas.Title>
				</Offcanvas.Header>
				<Offcanvas.Body className='menu-lateral'>
					<Nav className="flex-column">
						<Nav.Item>
							<Link to="/multischool/dashboard" className={`nav-link ${location.pathname === '/multischool/dashboard' ? 'active' : ''}`}>
								<img src="/images/menus/home.svg" alt="Icono Mi Perfil" className='me-3'/>
								{t('menus.home')}
							</Link>
						</Nav.Item>
						<Nav.Item>
							<Link to="/multischool/profile" className={`nav-link ${location.pathname === '/multischool/profile' ? 'active' : ''}`}>
								<img src="/images/menus/user.svg" alt="Icono Mi Perfil" className='me-3' />
								{t('menus.profile')}
							</Link>
						</Nav.Item>
						<Nav.Item>
							<Link to="/multischool/schools" className={`nav-link ${isSchoolsManagementActive(location.pathname) ? 'active' : ''}`}>
								<img src="/images/menus/experiencia.svg" alt="Centros" className='me-3' />
								{t('menus.schools')}
							</Link>
						</Nav.Item>
						<Nav.Item>
							<Accordion defaultActiveKey="0">
								<Accordion.Item eventKey="0" className="ps-1">
									<Accordion.Header>
										<img src="/images/config.svg" alt="Icono Mi Perfil" className='me-3'/>
										{t('menus.processes')}
									</Accordion.Header>
									<Accordion.Body>
										<Nav defaultActiveKey="/config" className="flex-column">
											{/* <Nav.Item>
												<Link to="/multischool/startprocess" className={`nav-link ${location.pathname === '/multischool/startprocess' ? 'active' : ''}`}>
													{t('menus.startprocess')}
												</Link>
											</Nav.Item> */}
											<Nav.Item>
												<Link to="/multischool/programprocess" className={`nav-link ${location.pathname === '/multischool/programprocess' ? 'active' : ''}`}>
													{t('menus.programprocess')}
												</Link>
											</Nav.Item>
											<Nav.Item>
												<Link to="/multischool/activeprocesses" className={`nav-link ${isactiveProcessesActive(location.pathname) ? 'active' : ''}`}>
													{t('menus.activeprocesses')}
												</Link>
											</Nav.Item>
											<Nav.Item>
												<Link to="/multischool/completedprocesses" className={`nav-link ${location.pathname === '/multischool/completedprocesses' ? 'active' : ''}`}>
													{t('menus.completedprocesses')}
												</Link>
											</Nav.Item>
										</Nav>
									</Accordion.Body>
								</Accordion.Item>
							</Accordion>
						</Nav.Item>
						<Nav.Item>
							<Link to="/multischool/database/favourites" className={`nav-link ${location.pathname === '/multischool/database/favourites' || location.pathname === '/multischool/database/blocked' ? 'active' : ''}`}>
								<img src="/images/menus/database.svg" alt="Data base" className='me-3'/>
								{t('menus.database')}
							</Link>
						</Nav.Item>
						<Nav.Item>
							<Link to="/multischool/tickets" className='nav-link'>
								<img src="/images/menus/ticket.svg" alt="Tickets" className='me-3'/>
								{t('menus.tickets')}
							</Link>
						</Nav.Item>
					</Nav>
				</Offcanvas.Body>
			</Offcanvas>
            <SchoolCalendar visible={showCalendar} setVisible={setShowCalendar}/>
        </header>
    )
}
